
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.948 3.028c.26-.337.655-.505 1.05-.506.528 0 1.056.298 1.265.898l.632 1.819c.184.528.677.886 1.236.897l1.925.04c1.267.025 1.79 1.636.78 2.402L12.302 9.74a1.337 1.337 0 00-.472 1.452l.557 1.843c.367 1.213-1.003 2.209-2.043 1.485l-1.58-1.1a1.336 1.336 0 00-1.528 0l-1.58 1.1c-.13.09-.265.154-.402.194-.954.278-1.963-.617-1.641-1.679l.557-1.843a1.34 1.34 0 00-.472-1.452L2.164 8.578c-1.01-.766-.487-2.377.78-2.403l1.925-.039a1.337 1.337 0 001.236-.897l.632-1.819a1.432 1.432 0 01.21-.392zm1.05 8.816c.535 0 1.07.16 1.53.48l1.58 1.1-.558-1.843a2.674 2.674 0 01.944-2.906l1.534-1.163-1.925-.039a2.674 2.674 0 01-2.47-1.796L8 3.86l-.002.007v7.979z","fill":"currentColor"}})])
          )
        }
      }
    